// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2H2Xo","close":"Item_close__3NoJt"};